import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Tag } from '@daedalus/atlas/Tag';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { DotSeparatedList } from '../DotSeparatedList';

// Tags have bottom margin to simulate row-gap, reset it so the rest of the layout can flow correctly
// This can be cleaned up when row-gap has enough browser support
const ShouldResetTagSpacing = /*#__PURE__*/styled('div')({
  name: "ShouldResetTagSpacing",
  class: "szfd2x8",
  propsAsIs: false
});
const TagSpacing = /*#__PURE__*/styled('div')({
  name: "TagSpacing",
  class: "tpvuwm5",
  propsAsIs: false
});
const TagWrapper = /*#__PURE__*/styled('div')({
  name: "TagWrapper",
  class: "tunk1nc",
  propsAsIs: false
});
const TagContainer = /*#__PURE__*/styled('div')({
  name: "TagContainer",
  class: "t1huccci",
  propsAsIs: false
});
interface Props {
  sentiments: ContentHotel['sentiments'];
  hasResetTagSpacing?: boolean;
  variant?: 'normal' | 'slider';
  isCompact?: boolean;
}
export const ReviewSentiments: React.FC<Props> = ({
  sentiments,
  hasResetTagSpacing = true,
  variant = 'normal',
  isCompact = false
}) => {
  const sentimentsToShow = sentiments?.slice(0, 6).filter(Boolean) || [];
  const values = sentimentsToShow.map(sentiment => sentiment.value);
  if (isCompact) {
    return <DotSeparatedList values={values} isSingleLine={variant === 'slider'} />;
  }
  if (variant === 'slider') {
    return <TagContainer>
        {sentimentsToShow.map(sentiment => <TagWrapper key={sentiment.id}>
            <Tag variant="neutral" size="md">
              {`"${sentiment.value}"`}
            </Tag>
          </TagWrapper>)}
      </TagContainer>;
  }
  return <ShouldResetTagSpacing className={cx(hasResetTagSpacing && 'hasSpacing')}>
      {sentimentsToShow.map(sentiment => <TagSpacing key={sentiment.id} className={cx(hasResetTagSpacing && 'hasSpacing')}>
          <Tag variant="neutral" size="md">
            {`"${sentiment.value}"`}
          </Tag>
        </TagSpacing>)}
    </ShouldResetTagSpacing>;
};

require("./ReviewSentiments.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewSentiments.tsx");